import type { CardProps } from '@zoopla-eng/zds/cards/property/house-prices';
import {
    BathroomMedium,
    BedroomMedium,
    LivingRoomMedium
} from '@zoopla-eng/zds/icons';

type AttributesInput = {
    beds?: number;
    baths?: number;
    receptions?: number;
};

export const mapAttributes = (attributes: AttributesInput) =>
    Object.entries(attributes)
        .filter(([_, val]) => val !== undefined && val !== null)
        .map(([key, val]) => {
            let icon;
            if (key === 'beds') icon = <BedroomMedium />;
            if (key === 'baths') icon = <BathroomMedium />;
            if (key === 'receptions') icon = <LivingRoomMedium />;

            return {
                value: val,
                text: val > 1 ? key : key.slice(0, -1),
                icon
            };
        }) as CardProps['attributes'];
